import React, { useEffect, useState } from "react";
import API_URL from "../../../../apiConfig";
import { Link } from "react-router-dom";
import AdminHeader from "../../../../components/AdminHeader";
import AdminPageHeader from "../../../../components/admin/AdminPageHeader";
import MediaPicker from "../../../../components/admin/MediaPicker";

export default function AdminSystems() {

  const [systems, setSystems] = useState([]);
  const [loading, setLoading] = useState(true);

  const [editingId, setEditingId] = useState(null);

  const [form, setForm] = useState({
    title: "",
    description: "",
    cover_url: "",
    estimated_days: "",
    status: ""
  });

  useEffect(() => {
    loadSystems();
  }, []);

  async function loadSystems() {
    try {
      const session = JSON.parse(localStorage.getItem("zedro_session"));

      const res = await fetch(`${API_URL}/api/systems`, {
        headers: {
          Authorization: `Bearer ${session?.token}`
        }
      });

      const json = await res.json();

      if (json.ok) setSystems(json.systems);

    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }

  function startEdit(system) {
    setEditingId(system.id);

    setForm({
      title: system.title || "",
      description: system.description || "",
      cover_url: system.cover_url || "",
      estimated_days: system.estimated_days || "",
      status: system.status || ""
    });

    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  function cancelEdit() {
    setEditingId(null);
    setForm({
      title: "",
      description: "",
      cover_url: "",
      estimated_days: "",
      status: ""
    });
  }

  function slugify(text) {
    return text
      .toLowerCase()
      .replace(/[^\w ]+/g, "")
      .replace(/ +/g, "-");
  }

  async function createSystem(e) {
    e.preventDefault();

    try {
      const session = JSON.parse(localStorage.getItem("zedro_session") || "{}");

      const payload = {
        ...form,
        slug: slugify(form.title)
      };

      const method = editingId ? "PUT" : "POST";

      const url = editingId
        ? `${API_URL}/api/systems/${editingId}`
        : `${API_URL}/api/systems`;

      const res = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${session?.token}`
        },
        body: JSON.stringify(payload)
      });

      const json = await res.json();

      if (!res.ok) throw new Error(json.error || "Error guardando sistema");

      setForm({
        title: "",
        description: "",
        estimated_days: "",
        status: ""
      });

      setEditingId(null);
      loadSystems();

    } catch (err) {
      console.error(err);
      alert(err.message);
    }
  }

  async function deleteSystem(id) {
  const confirmDelete = window.confirm("¿Seguro que deseas eliminar este sistema?");
  if (!confirmDelete) return;

  try {
    const session = JSON.parse(localStorage.getItem("zedro_session") || "{}");

    const res = await fetch(`${API_URL}/api/systems/${id}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${session?.token}`
      }
    });

    const json = await res.json();

    if (!res.ok) throw new Error(json.error || "Error eliminando sistema");

    // 🔥 refrescar lista
    loadSystems();

  } catch (err) {
    console.error(err);
    alert(err.message);
  }
}

  function renderStatus(status) {
    if (status === "draft") return "Borrador";
    if (status === "published") return "Publicado";
    if (status === "archived") return "Archivado";
    return status;
  }

  if (loading) return <div style={{ padding: 40 }}>Cargando sistemas...</div>;

  return (
    <>
      <AdminHeader />

      <div style={{ padding: 40, maxWidth: 1000, margin: "0 auto" }}>

        <AdminPageHeader
          title="Sistemas"
          subtitle="Crear y organizar sistemas de formación."
          backTo="/admin/produccion"
        />

        {editingId && (
          <div style={editBanner}>
            Editando sistema
          </div>
        )}

        {/* FORM */}
        <form onSubmit={createSystem} style={formBox}>

          <Label text="Título del sistema" />
          <Input
            placeholder="Ej: Finanzas con propósito"
            value={form.title}
            onChange={(v) => setForm({ ...form, title: v })}
            required
          />

          <Label text="Descripción" />
          <Textarea
            placeholder="Descripción completa del sistema. Puedes usar saltos de línea y **negrita**."
            value={form.description}
            onChange={(v) => setForm({ ...form, description: v })}
          />

          <Label text="Imagen del sistema" />
          <MediaPicker
            value={form.cover_url}
            onChange={(url) => setForm({ ...form, cover_url: url })}
            allowedKinds={["image", "file"]}
            label="Seleccionar imagen desde Media"
          />

          {form.cover_url && (
            <div
              style={{
                width: "100%",
                height: 180,
                borderRadius: 18,
                overflow: "hidden",
                border: "1px solid #e6ebf1",
                background: "#f8fafc",
              }}
            >
              <img
                src={form.cover_url}
                alt="Vista previa del sistema"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  display: "block",
                }}
              />
            </div>
          )}

          <Label text="Duración (días)" />
          <Input
            type="number"
            placeholder="Ej: 30"
            value={form.estimated_days}
            onChange={(v) =>
              setForm({ ...form, estimated_days: v })
            }
          />

          <Label text="Estado" />
          <Select
            value={form.status}
            onChange={(v) => setForm({ ...form, status: v })}
          />

          <button style={primaryBtn}>
            {editingId ? "Guardar cambios" : "Crear sistema"}
          </button>

          {editingId && (
            <button type="button" onClick={cancelEdit} style={secondaryBtn}>
              Cancelar edición
            </button>
          )}

        </form>

        {/* LIST */}
        <div style={{ display: "grid", gap: 14 }}>

          {systems.map((system) => (
            <div key={system.id} style={cardStyle}>

              <div style={cardTitle}>{system.title}</div>

              {system.description && (
                <div style={cardDesc}>{system.description}</div>
              )}

              <div style={cardMeta}>
                {system.estimated_days} días · {renderStatus(system.status)}
              </div>

              <div style={cardActions}>

                <Link
                  to={`/admin/systems/${system.id}/sections`}
                  style={linkStyle}
                >
                  Secciones →
                </Link>

                <div style={actionsRight}>

                   <button onClick={() => startEdit(system)} style={editBtn}>
                    Editar
                  </button>

                  <button
                    onClick={() => deleteSystem(system.id)}
                    style={deleteBtnInline}
                  >
                    Eliminar
                  </button>

                </div>

              </div>

            </div>
          ))}

        </div>

      </div>
    </>
  );
}

/* UI COMPONENTES */

const Label = ({ text }) => (
  <label style={{ fontWeight: 600 }}>{text}</label>
);

const Input = ({ value, onChange, ...props }) => (
  <input
    {...props}
    value={value}
    onChange={(e) => onChange(e.target.value)}
    style={inputStyle}
  />
);

const Textarea = ({ value, onChange, ...props }) => (
  <textarea
    {...props}
    value={value}
    onChange={(e) => onChange(e.target.value)}
    style={inputStyle}
  />
);

const Select = ({ value, onChange }) => (
  <select
    value={value}
    onChange={(e) => onChange(e.target.value)}
    style={inputStyle}
  >
    <option value="">Seleccionar estado</option>
    <option value="draft">Borrador</option>
    <option value="published">Publicado</option>
    <option value="archived">Archivado</option>
  </select>
);

/* STYLES */

const formBox = {
  display: "grid",
  gap: 10,
  marginBottom: 30,
  padding: 20,
  borderRadius: 12,
  background: "#fff",
  border: "1px solid #e6ebf1"
};

const inputStyle = {
  padding: 10,
  borderRadius: 8,
  border: "1px solid #ddd"
};

const primaryBtn = {
  padding: "10px 16px",
  background: "#0a2230",
  color: "#fff",
  border: "none",
  borderRadius: 8,
  cursor: "pointer",
  fontWeight: 600
};

const secondaryBtn = {
  padding: "8px 12px",
  background: "#f3f4f6",
  border: "none",
  borderRadius: 8,
  cursor: "pointer"
};

const editBanner = {
  marginBottom: 20,
  padding: 12,
  background: "#fff8e1",
  border: "1px solid #f0d98c",
  borderRadius: 8,
  fontWeight: 600
};

const cardStyle = {
  padding: 16,
  borderRadius: 12,
  border: "1px solid #e6ebf1",
  background: "#fff"
};

const cardTitle = {
  fontWeight: 700,
  fontSize: 18
};

const cardDesc = {
  marginTop: 6,
  color: "#6b7a88"
};

const cardMeta = {
  marginTop: 8,
  fontSize: 13,
  color: "#9ca3af"
};

const cardActions = {
  marginTop: 12,
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center"
};

const linkStyle = {
  textDecoration: "none",
  color: "#286b94",
  fontWeight: 600
};

const editBtn = {
  border: "1px solid #ddd",
  padding: "6px 10px",
  borderRadius: 6,
  cursor: "pointer",
  background: "#fff"
};

const deleteBtn = {
  border: "1px solid #ddd",
  padding: "6px 10px",
  borderRadius: 6,
  background: "#fff",
  cursor: "pointer"
};

const actionsRight = {
  marginLeft: "auto",
  display: "flex",
  gap: "8px"
};

const deleteBtnInline = {
  background: "transparent",
  border: "1px solid #e5e7eb",
  color: "#111827",
  padding: "6px 10px",
  borderRadius: 8,
  cursor: "pointer"
};